interface StudyUpgradeBannerProps {
  description: string;
  image: string;
  onClick: () => void;
  title: string;
}

export function StudyUpgradeBanner({
  description,
  image,
  onClick,
  title,
}: StudyUpgradeBannerProps) {
  return (
    <button className="relative flex min-h-[120px] w-full items-center overflow-hidden rounded-[28px] bg-[var(--dp-brand-button)] px-8 text-left text-white shadow-[0_4px_4px_rgba(0,0,0,0.12)]" onClick={onClick} type="button">
        <div className="flex items-center gap-6">
          <img alt="" className="h-[92px] w-[80px] shrink-0 object-contain" src={image} />
          <div>
            <h2 className="text-2xl font-semibold leading-8">{title}</h2>
            <p className="mt-1 max-w-[860px] text-base leading-6 text-white/95">{description}</p>
          </div>
        </div>
    </button>
  );
}
